import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import GrowthOpportunityViewComp from './GrowthOpportunityViewComp';

function GrowthOpportunityView() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <GrowthOpportunityViewComp />
      </div>
    </div>
  );
}

export default GrowthOpportunityView;
